module.exports = __webpack_public_path__ + "static/media/criteria-10.2-rsp.2bb267e0.jpg";